import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { CustomerAddress } from '../../../../types/customers';
import { InfoItemDd, InfoItemDt, InfoItemList } from '../../../common';
import styled from 'styled-components/macro';
import { Button } from '../../../../components/Buttons';

interface Props extends WithTranslation {
    address: CustomerAddress;
    onEdit: (i: number) => void;
    onDelete: (i: number) => void;
    index: number;
}

const Address = (
    {
        address,
        t,
        onEdit,
        index,
        onDelete,
    }: Props
) => {
    return (
        <Container>
            <InfoItemList>
                <InfoItemDt>{t('customers.customer.addresses.address')}</InfoItemDt>
                <InfoItemDd>
                    {address.address_line}
                    {address.address_line_2 && (
                        <>
                            <br />
                            {address.address_line_2}
                        </>
                    )}
                </InfoItemDd>
            </InfoItemList>

            {address.postal_code && (
                <InfoItemList>
                    <InfoItemDt>{t('customers.customer.addresses.postal_code')}</InfoItemDt>
                    <InfoItemDd>{address.postal_code}</InfoItemDd>
                </InfoItemList>
            )}

            <InfoItemList>
                <InfoItemDt>{t('customers.customer.addresses.postal_place')}</InfoItemDt>
                <InfoItemDd>{address.postal_place}</InfoItemDd>
            </InfoItemList>

            <InfoItemList>
                <InfoItemDt>{t('customers.customer.addresses.country')}</InfoItemDt>
                <InfoItemDd>{address.country}</InfoItemDd>
            </InfoItemList>

            {address.type && (
                <InfoItemList>
                    <InfoItemDt>{t('customers.customer.addresses.type')}</InfoItemDt>
                    <InfoItemDd>{t(`customers.customer.addresses.form.types.${address.type}`)}</InfoItemDd>
                </InfoItemList>
            )}

            {address.type === 'custom' && (
                <InfoItemList>
                    <InfoItemDt>{t('customers.customer.addresses.custom_type')}</InfoItemDt>
                    <InfoItemDd>{address.custom_type}</InfoItemDd>
                </InfoItemList>
            )}

            <InfoItemList>
                <InfoItemDt>{t('customers.customer.addresses.comment')}</InfoItemDt>
                <InfoItemDd>{address.comment}</InfoItemDd>
            </InfoItemList>

            <ButtonContainer>
                <Button className="tiny" onClick={() => onEdit(index)}>
                    {t('customers.customer.addresses.edit')}
                </Button>
                <Button className="tiny" onClick={() => onDelete(index)}>
                    {t('customers.customer.addresses.delete')}
                </Button>
            </ButtonContainer>
        </Container>
    );
};

const Container = styled.div`
    flex: 0 0 50%;
    position: relative;
    @media (max-width: 1024px) {
        flex: 1 0 100%;
    }
`;

const ButtonContainer = styled.div`
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.5);
    ${Container}:hover & {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ${Button} + ${Button} {
        margin-left: 4px;
    }
`;

export default withTranslation()(Address);
